<template>
  <div class="intro-y flex flex-col sm:flex-row justify-between items-end mt-8">
    <div class="flex flex-row items-end">
      <div
        class="px-8 py-2 text-2xl font-bold text-primary-1 border-primary-1 border text-center rounded-md"
      >
        Special Path
      </div>
      <h2 class="text-lg font-medium ml-4"></h2>
    </div>
    <div class="flex justify-end mt-4 sm:mt-0" v-if="!loadingPage">
      <router-link
        type="button"
        :to="{ name: 'specialPathAll' }"
        class="btn box text-gray-700 mr-2 flex items-center ml-auto sm:ml-0"
      >
        <ArrowLeftIcon class="w-4 h-4 mr-2 hidden md:block" /> Back
      </router-link>
      <button
        type="button"
        class="btn btn-primary disabled:opacity-50 mr-2 flex items-center ml-auto sm:ml-0"
        @click.prevent="saveSpecialPath()"
        :disabled="btnSave.disabled"
      >
        <FileTextIcon
          class="w-4 h-4 mr-2 hidden md:block"
          v-if="!btnSave.loading"
        />
        <LoadingIcon icon="oval" color="white" v-else class="w-4 h-4 mr-2" />
        บันทึก
      </button>
      <a
        href="javascript:;"
        class="btn btn-danger disabled:opacity-50 mr-2 flex items-center ml-auto sm:ml-0"
        data-toggle="modal"
        data-target="#delete-special-path-modal-preview"
        :disabled="btnDelete.disabled"
        v-show="isEdit"
      >
        <Trash2Icon
          class="w-4 h-4 mr-2 hidden md:block"
          v-if="!btnDelete.loading"
        />
        <LoadingIcon icon="oval" color="white" v-else class="w-4 h-4 mr-2" />
        ลบทิ้ง
      </a>
    </div>
  </div>

  <div class="grid grid-cols-12 gap-6 mt-5">
    <div class="intro-y col-span-12">
      <div class="mt-5">
        <div class="h-10 w-full text-center my-20" v-if="loadingPage">
          <LoadingIcon icon="oval" class="w-12 h-12" />
        </div>
        <div class="horizontal-form" v-else>
          <div class="intro-y box p-5 space-y-4">
            <div class="text-lg font-bold">
              ข้อมูลสายการอนุมัติ
            </div>
            <div>
              <div class="w-full">
                <div>
                  <label class="form-label"
                    >ชื่อสายอนุมัติ <span class="text-theme-6">*</span></label
                  >
                  <div>
                    <input
                      type="text"
                      refs="titleRef"
                      class="form-control w-full"
                      v-model.trim="validateSpecial.specialPathName.$model"
                      :class="{
                        'border-theme-6': validateSpecial.specialPathName.$error
                      }"
                      :disabled="isEdit"
                    />
                  </div>
                </div>
                <div class="mt-4">
                  <label class="form-label"
                    >หน่วยงาน / บริษัท
                    <span class="text-theme-6">*</span></label
                  >
                  <select
                    name=""
                    v-model="companySelected"
                    @change="onChangeDocumentPath({ target: 'select-company' })"
                    class="form-select w-full"
                    :disabled="isEdit"
                  >
                    <option
                      v-for="company in companyOptions"
                      :key="company.comp_no"
                      :value="company.comp_no"
                      >{{ company.comp_name_th }}</option
                    >
                  </select>
                </div>
                <div class="mt-4">
                  <label class="form-label">สายอนุมัติใหม่ </label>
                  <div>
                    {{ displayText }}
                  </div>
                </div>
                <div class="mt-4">
                  <label class="form-label">ลำดับการอนุมัติ</label>
                  <div class="preview w-full">
                    <WfSelect
                      key="wfselect-employee"
                      v-model="employeeSelected"
                      :options="{
                        search: true,
                        multiple: true,
                        multipleLimit: 100,
                        searchMinLength: 3,
                        items: optionEmployee,
                        labelBy: 'fullname_th',
                        valueBy: 'employee_id'
                      }"
                    ></WfSelect>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- BEGIN: Modal Content -->
    <div
      id="delete-special-path-modal-preview"
      class="modal"
      tabindex="-1"
      data-backdrop="static"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body p-0">
            <div class="p-5 text-center">
              <XCircleIcon class="w-16 h-16 text-theme-6 mx-auto mt-3" />
              <div class="text-3xl mt-5">คุณแน่ใจ</div>
              <div class="text-gray-600 mt-2">
                ต้องการลบรายการนี้ ใช่ หรือ ไม่?
              </div>
            </div>
            <div class="px-5 pb-8 text-center">
              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-outline-secondary w-24 dark:border-dark-5 dark:text-gray-300 mr-1"
              >
                ไม่
              </button>
              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-danger w-24"
                @click="confirmDeleteSpecialPath()"
              >
                ใช่
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END: Modal Content -->
  </div>
</template>

<script>
import { computed, onUnmounted, onMounted, reactive, ref, watch } from 'vue'
import { useStore } from '@/store'
import { useRoute } from 'vue-router'
import { api } from '@/utils/api'
import alert from '@/helpers/alert'
import helpers from '@/helpers'
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'

import WfSelect from '@/components/select/Main.vue'
import router from '../../router'

export default {
  components: {
    WfSelect
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    store.dispatch('global/loadEmployeeAll')
    const loadingPage = computed(() => store.state.global.loadingPage)
    const companyOptions = computed(() => store.state.global.company)

    const optionEmployee = computed(() => store.state.global.employeeAll)
    const btnSave = reactive({
      disabled: false,
      loading: false
    })

    const btnDelete = reactive({
      disabled: false,
      loading: false
    })

    const isEdit = ref(route.params.name != undefined)

    const rules = {
      specialPathName: { required },
      companySelected: { required }
    }

    const { numberFormat } = helpers

    const specialPathName = ref()
    const companySelected = ref()
    const employeeSelected = ref([])
    const displayText = ref(null)

    const validateSpecial = useVuelidate(rules, {
      specialPathName,
      companySelected
    })

    const saveSpecialPath = async () => {
      validateSpecial.value.$touch()
      if (validateSpecial.value.$invalid) {
        alert.error()
        return false
      }
      // disabled and loading
      btnSave.disabled = true
      btnSave.loading = true

      const data = {
        name: specialPathName.value,
        comp_no: companySelected.value,
        employee_list: employeeSelected.value
      }
      if (isEdit.value) {
        await api
          .put('admin/documentPath/updateSpecialPathJsonData', data)
          .then(res => {
            if (res.code == 200) {
              btnSave.disabled = false
              btnSave.loading = false
              alert.success()
            } else {
              btnSave.disabled = false
              btnSave.loading = false
              alert.error(res.message)
            }
          })
          .catch(e => {
            btnSave.disabled = false
            btnSave.loading = false
            alert.error(e.message)
          })
      } else {
        await api
          .post('admin/documentPath/insertSpecialPathJsonData', data)
          .then(res => {
            if (res.code == 200) {
              btnSave.disabled = false
              btnSave.loading = false
              alert.success()
              isEdit.value = true
            } else {
              btnSave.disabled = false
              btnSave.loading = false
              alert.error(res.message)
            }
          })
          .catch(e => {
            btnSave.disabled = false
            btnSave.loading = false
            alert.error(e.message)
          })
      }
    }

    const confirmDeleteSpecialPath = async () => {
      btnDelete.disabled = true
      btnDelete.loading = true

      await api
        .delete(
          `admin/documentPath/deletedSpecialPathCompany/${specialPathName.value}`
        )
        .then(res => {
          if (res.code == 200) {
            btnDelete.disabled = false
            btnDelete.loading = false
            alert.success()
            setTimeout(() => {
              router.push({ name: 'specialPathAll' })
            }, 500)
          } else {
            btnDelete.disabled = false
            btnDelete.loading = false
            alert.error(res.message)
          }
        })
        .catch(e => {
          btnDelete.disabled = false
          btnDelete.loading = false
          alert.error(e.message)
        })
    }

    const getSpecialPathInfo = async () => {
      if (route.params.name) {
        await api
          .get(`/admin/documentPath/getSpecialPathCompany/${route.params.name}`)
          .then(res => {
            // console.log('res: ', res.data.name)
            if (res.code == 200 && res.data != null) {
              specialPathName.value = res.data.name
              companySelected.value = res.data.comp_no
              employeeSelected.value = res.data.json_data_array
                ? res.data.json_data_array.approve_path.map(v => v.employee_id)
                : []
            } else {
              if (res.data == null) {
                alert.error('ไม่สามารถดึงได้ข้อมูล')
              } else {
                alert.error(res.message)
              }
            }
          })
          .catch(e => {
            alert.error(e.message)
          })
      }

      store.commit('global/setLoadingPage', false)
    }

    const getUserLoa = async () => {
      await api
        .get(
          `/admin/documentPath/getUserLoaSpecialPath?employeeId=${employeeSelected.value.join(
            ','
          )}`
        )
        .then(res => {
          // console.log('res: ', res)
          const tmp = []
          if (res.code == 200) {
            for (const emp of res.data) {
              // console.log('emp: ', emp)
              let lvText = ''
              if (emp.credit_limit) {
                if (emp.hr_level == emp.wf_level) {
                  lvText = `(Lv: ${emp.wf_level} Cr: ${numberFormat(
                    emp.credit_limit
                  )})`
                } else {
                  lvText = `(Lv: ${emp.hr_level} - ${
                    emp.wf_level
                  } Cr: ${numberFormat(emp.credit_limit)})`
                }
              }
              tmp.push(`${emp.fullname_th} ${lvText}`)
            }
          }
          displayText.value = tmp.join(' => ')
        })
        .catch(e => {
          console.log('error: ', e)
        })
    }

    watch(employeeSelected, () => {
      // console.log(
      //   'emp:',
      //   employeeSelected.value,
      //   employeeSelected.value.join(',')
      // )
      getUserLoa()
    })

    onUnmounted(() => {
      console.log('unmounted page special path form')
      store.commit('global/setLoadingPage', true)
    })

    onMounted(async () => {
      console.log('mounted page special path form')
      await store.dispatch('global/loadCompany')
      await getSpecialPathInfo()
    })

    return {
      loadingPage,
      btnSave,
      btnDelete,
      saveSpecialPath,
      companyOptions,
      companySelected,
      employeeSelected,
      numberFormat,
      optionEmployee,
      specialPathName,
      displayText,
      validateSpecial,
      isEdit,
      confirmDeleteSpecialPath
    }
  }
}
</script>

<style scoped>
.vue-select {
  width: 100%;
  border-radius: 0.375rem;
  border-width: 1px;
  border-color: #e2e8f0;
  border-style: solid;
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
</style>
